import { IntlProvider } from 'react-intl';
import { MemoryRouter } from 'react-router';
import { ReactElement } from 'react';
import { RenderOptions, RenderResult, render } from '@testing-library/react';

import { noop } from './noop';

export type MockProvider = (component: ReactElement, providerOptions?: Record<string, unknown>) => ReactElement;

export const IntlMockProvider: MockProvider = component => (
    <IntlProvider locale={'de'} onError={noop}>
        {component}
    </IntlProvider>
);

export const RouterMockProvider: MockProvider = component => <MemoryRouter>{component}</MemoryRouter>;

const addProviders = (
    component: ReactElement,
    providers: MockProvider[],
    providerOptions?: Record<string, unknown>
): ReactElement => {
    return providers.reduce((result, current) => {
        return current(result, providerOptions);
    }, component);
};
export const createRenderWithMockProvider =
    (provider: MockProvider[], providerOptions?: Record<string, unknown>) =>
    (ui: ReactElement, options?: Omit<RenderOptions, 'queries'>): RenderResult =>
        render(addProviders(ui, provider, providerOptions), options);
